import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ValidatorEditorBase } from '../validator-editor-base/validator-editor-base';
import { DigitTypeValidatorValue } from '../../../types/validator.types';

@Component({
  selector: 'df-digital-type-validator-editor',
  templateUrl: './digital-type-validator-editor.component.html',
  styleUrls: ['./digital-type-validator-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DigitalTypeValidatorEditorComponent extends ValidatorEditorBase<DigitTypeValidatorValue>
  implements OnInit {
  ngOnInit(): void {
    if (!this.caption) {
      this.caption = 'æ°å¼ç±»å';
    }
  }

  defaultModelData(): DigitTypeValidatorValue {
    return {
      isInteger: undefined,
      isFloat: undefined,
      float: {
        decimalPlaces: undefined
      }
    };
  }
  input() {
    this.emitModelChange();
  }

  select(event: any) {
    const validatorModel = this.model;

    validatorModel.data.isInteger = false;
    validatorModel.data.isFloat = false;

    if (event.target.value === 'isInteger') {
      validatorModel.data.isInteger = true;
    }
    if (event.target.value === 'isFloat') {
      validatorModel.data.isFloat = true;
    }
    this.emitModelChange();
  }
}
